import { resources } from "@constants/hardcoded-strings";
import { formatMessagingTemplate } from "@formatters/messaging-templates/messaging-template-formatter";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";
import { setMessagingTemplateDetails } from "@redux/actions/messaging-template-details-actions";
import { updateMessagingTemplateRequest } from "@requests/axnadmin-core/update-messaging-templates";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getUnformattedLanguageFiles } from "@utils/messaging-template/messaging-template-util";
import { Dispatch } from "redux";

export const updateMessagingTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    messagingTemplate: FormattedMessagingTemplate,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
) => {
    const { data, error, body } = await updateMessagingTemplateRequest(
        messagingTemplate.id,
        messagingTemplate.template,
        messagingTemplate.name,
        messagingTemplate.company?.id,
        messagingTemplate.relyingParty?.id,
        messagingTemplate.type,
        getUnformattedLanguageFiles(messagingTemplate.languageFiles),
        messagingTemplate.status,
        messagingTemplate.uuid,
        messagingTemplate.permissions
    );

    if (data) {
        // the permissions are empty. I decided to use the permissions that are previously set in the GET function 
        const formattedMessagingTemplate = formatMessagingTemplate({ ...data, permissions: messagingTemplate.permissions }, axnCompanies, axnRelyingParties);
        dispatch(setMessagingTemplateDetails(formattedMessagingTemplate));

        displaySuccessModal(
            dispatch,
            resources.requests.updateMessagingTemplate.success.title,
            resources.requests.updateMessagingTemplate.success.message
        );
        return formattedMessagingTemplate;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateMessagingTemplate.error.title,
            resources.requests.updateMessagingTemplate.error.message,
            null,
            null,
            body
        );
    }

    return null;
};